export const version = "bignumber/5.1.0";
